export const selectStyle = {
	wrapper: {
		position: 'relative',
		width: '100%',
	} as any,

	placeholder: {
		color: 'var(--neutral-200)',
	},

	optionItem: {
		display: 'flex',
		justifyContent: 'space-between',
	},

	icon: {
		display: 'flex',
		alignItems: 'center',
		marginRight: '12px',
	},

	iconError: {
		'& path': {
			fill: 'var(--error-500)',
		},
	},

	iconDisabled: {
		'& path': {
			fill: 'var(--neutral-200)',
		},
	},

	iconRotate: {
		'& svg': {
			transform: 'rotate(180deg)',
		},
	},
};
